import { app } from "@microsoft/teams-js";
import { TeamInfoDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { FetchResult, channelApi, isSuccess } from "../services/ChannelApi";

export const useTeamsDetails = () => {
  const [teamsDetails, setTeamsDetails] = useState<TeamInfoDTO>();
  const [isTeamsDetailsLoading, setIsTeamsDetailsLoading] = useState<boolean>(false);
  const [isTeamsDetailsLoaded, setIsTeamsDetailsLoaded] = useState<boolean>(false);
  const [teamsDetailsErrors, setTeamsDetailsErrors] = useState<FetchResult<TeamInfoDTO>>();

  const loadTeamsDetails = useCallback(
    async (context: app.Context, fetchCountFromRemote?: boolean) => {
      setIsTeamsDetailsLoading(true);
      setTeamsDetailsErrors(undefined);
      const result = await channelApi.getTeamInfo(context, undefined, fetchCountFromRemote);
      if (isSuccess(result)) {
        setTeamsDetails(result);
        setIsTeamsDetailsLoaded(true);
      } else {
        setTeamsDetailsErrors(result);
      }
      setIsTeamsDetailsLoading(false);
    },
    []
  );

  const clearTeamsDetailsErrors = () => {
    setTeamsDetailsErrors(undefined);
  };

  return {
    loadTeamsDetails,
    teamsDetails,
    teamsDetailsErrors,
    isTeamsDetailsLoading,
    isTeamsDetailsLoaded,
    clearTeamsDetailsErrors,
  };
};
